export const DEFAULT_REFERRAL_REWARDS = {
  enabled: true,
  referralsRequired: 1,
  goldenTickets: 1,
  maxReferrals: 10,
};

export function normalizeReferralRewards(raw) {
  const v = raw && typeof raw === 'object' ? raw : {};
  const enabled = v.enabled !== false;
  let referralsRequired = parseInt(v.referralsRequired, 10);
  let goldenTickets = parseInt(v.goldenTickets, 10);
  let maxReferrals = parseInt(v.maxReferrals, 10);
  if (!Number.isInteger(referralsRequired) || referralsRequired < 1) {
    referralsRequired = 1;
  }
  if (!Number.isInteger(goldenTickets) || goldenTickets < 0) {
    goldenTickets = Math.max(0, parseInt(v.goldenTicketsPerReferral, 10) || DEFAULT_REFERRAL_REWARDS.goldenTickets);
  }
  if (!Number.isInteger(maxReferrals) || maxReferrals < 0) {
    maxReferrals = DEFAULT_REFERRAL_REWARDS.maxReferrals;
  }
  return { enabled, referralsRequired, goldenTickets, maxReferrals };
}

export function formatReferralRewardSentence(raw) {
  const { referralsRequired, goldenTickets, enabled } = normalizeReferralRewards(raw);
  if (!enabled || goldenTickets <= 0) {
    return 'Referral rewards are currently paused.';
  }
  const ticketWord = goldenTickets === 1 ? 'golden ticket' : 'golden tickets';
  if (referralsRequired === 1) {
    return `Earn ${goldenTickets} ${ticketWord} for each friend who signs up with your link and makes their first free prediction.`;
  }
  return `Earn ${goldenTickets} ${ticketWord} for every ${referralsRequired} friends who sign up with your link and make their first free prediction.`;
}

export function formatReferralRewardShort(raw) {
  const { referralsRequired, goldenTickets, enabled } = normalizeReferralRewards(raw);
  if (!enabled || goldenTickets <= 0) return 'Paused';
  const ticketWord = goldenTickets === 1 ? 'ticket' : 'tickets';
  if (referralsRequired === 1) {
    return `${goldenTickets} golden ${ticketWord} per verified player`;
  }
  return `${goldenTickets} golden ${ticketWord} per ${referralsRequired} verified players`;
}
